import React from 'react';
import CareersPage from '../../../components/careers';

const Careers = (props) => (
  <CareersPage {...props}/>
);

export default Careers;
